<template>
    <div class="mian_page">
        <div class="desktop-element">
            <div class="page_contact flex-col">
                <my-menu class="sticky-menu" :default-active-index="4"></my-menu>
                <div class="contact_us flex-col" :style="bannerStyle">
                    <div class="text-group_108 flex-col justify-between">
                        <span class="text_8">联系我们</span>
                        <span class="text_9">Contact&nbsp;us</span>
                    </div>
                </div>
                <div class="group_39 flex-row justify-between">
                    <div :class="['text-wrapper', selectIndex===0 ? 'text-wrapper_2' : 'text-wrapper_3']"
                         @click="switchTab('contact')"
                         @mouseover="hoverIndexFun(0) "
                         @mouseleave="offhoverIndexFun(0)"
                    ><span :class=" selectIndex===0 ? 'text_10' : 'text-11'">联系我们</span></div>
                    <div :class="['text-wrapper', selectIndex===1 ? 'text-wrapper_2' : 'text-wrapper_3']"
                         @click="switchTab('join')"
                         @mouseover="hoverIndexFun(1) "
                         @mouseleave="offhoverIndexFun(1)"
                    ><span :class=" selectIndex===1 ? 'text_10' : 'text-11'">加入康柏</span></div>
                </div>
                <div class="tab-content">
                    <div v-if="activeTab === 'contact'">
                        <contact-item :contactData="contactData"></contact-item>
                    </div>
                    <div v-if="activeTab === 'join'">
                        <join-item :joinData="joinData"></join-item>
                    </div>
                </div>

                <ChpcFooter></ChpcFooter>
                <contact-float v-show="isVisible" @change="change" />
                <contact-dialog v-show="!isVisible" @showContact="showContact"></contact-dialog>

            </div>
        </div>
        <div class="mobile-element">
            <div class="mobile-page flex-col">
                <mobile-header class="sticky-menu-mobile" :default-active-index="4"></mobile-header>
                <div class="mobile-link">
                    <mobile-link :default-active-index="4"></mobile-link>
                    <mobile-banner :contactBanner="aboutBanner"></mobile-banner>
                </div>
                <div class="group_39 flex-row justify-between">
                    <div :class="['text-wrapper', selectIndex===0 ? 'text-wrapper_2' : 'text-wrapper_3']"
                         @click="switchTab('contact')"
                         @mouseover="hoverIndexFun(0) "
                         @mouseleave="offhoverIndexFun(0)"
                    ><span :class=" selectIndex===0 ? 'text_10' : 'text-11'">联系我们</span></div>
                    <div :class="['text-wrapper', selectIndex===1 ? 'text-wrapper_2' : 'text-wrapper_3']"
                         @click="switchTab('join')"
                         @mouseover="hoverIndexFun(1) "
                         @mouseleave="offhoverIndexFun(1)"
                    ><span :class=" selectIndex===1 ? 'text_10' : 'text-11'">加入康柏</span></div>
                </div>
                <div class="tab-content">
                    <div v-if="activeTab === 'contact'">
                        <mobile-contact :contactData="contactData"></mobile-contact>
                    </div>
                    <div v-if="activeTab === 'join'">
                        <mobile-join></mobile-join>
                    </div>
                </div>

                <mobile-footer @contactMobile="contactMobile"></mobile-footer>
                <mobile-contact-dialog v-show="isVisibleMobile" @closeMobileContact="closeMobileContact"></mobile-contact-dialog>

            </div>
        </div>
    </div>
</template>
<script>
    import myMenu from "@/views/Component/ChpcMenu.vue";
    import ChpcFooter from "@/views/Component/ChpcFooter";
    import ContactFloat from "@/views/Component/Contact.vue";
    import ContactDialog from "@/views/Component/ContactDialog";
    import contactItem from "./childPage/contactItem";
    import joinItem from "./childPage/joinItem";
    //mobile
    import MobileHeader from "@/views/Component/MobileHeader";
    import MobileLink from "@/views/Component/MobileLink";
    import MobileFooter from "@/views/Component/MobileFooter";
    import MobileContact from "./childPage/MobileContact";
    import MobileJoin from "./childPage/MobileJoin";
    import MobileBanner from "./childPage/MobileBanner";
    import MobileContactDialog from "@/views/Component/MobileContactDialog";
    import {isNull} from "../../common/testFun";
    import commonFun from "@/util/common.js";
    import MobileServer from "../Index/childPage/MobileServer";

    export default {
        name: "contactIndex",
        metaInfo:{
            title:'北京康柏汉森医药科技咨询有限责任公司',
            meta:[{name: 'keyWords', content:'官网，CHPC，医药咨询，康柏汉森，医药科技咨询；医药企业营销咨询；企业管理咨询；商务咨询'},
                {name:'description', content:'简称CHPC, 上海分公司地址变更为:上海市黄浦区蒙自路757号平安滨江金融中心30层3001室'},
                {name:"robots",content:"北京康柏汉森医，联系方式"},
            ]
        },
        data() {
            return {
                aboutBanner:require('@/assets/contact/contact_banner_01.png'),
                isVisible:true,
                isVisibleMobile:false,
                activeTab: 'contact',
                selectIndex:0,
                hoverIndex:-1,
                showMenueMore:false,
                contactBanner: require('@/assets/contact/contact_banner_01.png'),
                contactData: [
                    {
                        lanhuBg0: require('@/assets/contact/contact_list_bj.png'),
                        addressIcon: require('@/assets/contact/contact_address.png'),
                        lanhutext0: '北京总公司',
                        lanhutext1: '北京市朝阳区建国路93号院万达广场8号楼2606室',
                        lanhutext2:
                            'Room&nbsp;2606,Block&nbsp;8,Wanda&nbsp;Plaza,No.93&nbsp;Jianguo&nbsp;Road,&nbsp;Chaoyang&nbsp;District,&nbsp;Beijing&nbsp;100022,P.R.China',
                        lanhutext3: '电话',
                        lanhutext4: ':',
                        lanhutext5: '010-58204887',
                        lanhuBg5: require('@/assets/contact/contact_address_bj.png'),
                        slot1: 1
                    },
                    {
                        lanhuBg0: require('@/assets/contact/contact_list_bj.png'),
                        addressIcon: require('@/assets/contact/contact_address.png'),
                        lanhutext0: '上海分公司',
                        lanhutext1: '上海市黄浦区蒙自路757号平安滨江金融中心30层3001室',
                        lanhutext2:
                            'Suite&nbsp;3001,&nbsp;30/F,&nbsp;Ping&nbsp;An&nbsp;Binjiang&nbsp;Financial&nbsp;Center,&nbsp;No.&nbsp;757&nbsp;Mengzi&nbsp;Road,&nbsp;Huangpu&nbsp;District,&nbsp;Shanghai&nbsp;200023,&nbsp;P.R.China',
                        lanhutext3: '电话',
                        lanhutext4: ':',
                        lanhutext5: '021-63331086',
                        lanhuBg5: require('@/assets/contact/contact_address_sh.png'),
                    }
                ],
                contactDataMobile: [
                    {
                        lanhuBg0: require('@/assets/contact/contact_list_bj.png'),
                        addressIcon: require('@/assets/contact/contact_address.png'),
                        lanhutext0: '北京总公司',
                        lanhutext1: '北京市朝阳区建国路93号院万达广场8号楼2606室',
                        lanhutext2:
                            'Room&nbsp;2606,Block&nbsp;8,Wanda&nbsp;Plaza,No.93&nbsp;Jianguo&nbsp;Road,'+ '<br/>'+
                        'Chaoyang&nbsp;District,&nbsp;Beijing&nbsp;100022,P.R.China',
                        lanhutext3: '电话',
                        lanhutext4: ':',
                        lanhutext5: '010-58204887',
                        lanhuBg5: require('@/assets/contact/contact_address_bj.png'),
                        slot1: 1
                    },
                    {
                        lanhuBg0: require('@/assets/contact/contact_list_bj.png'),
                        addressIcon: require('@/assets/contact/contact_address.png'),
                        lanhutext0: '上海分公司',
                        lanhutext1: '上海市黄浦区蒙自路757号平安滨江金融中心30层3001室',
                        lanhutext2:
                            'Suite&nbsp;3001,&nbsp;30/F,&nbsp;Ping&nbsp;An&nbsp;Binjiang&nbsp;Financial&nbsp;Center,&nbsp;No.&nbsp;757&nbsp;' + '<br/>'+
                            'Mengzi&nbsp;Road,&nbsp;Huangpu&nbsp;District,&nbsp;Shanghai&nbsp;200023,&nbsp;P.R.China',
                        lanhutext3: '电话',
                        lanhutext4: ':',
                        lanhutext5: '021-63331086',
                        lanhuBg5: require('@/assets/contact/contact_address_sh.png'),
                    }
                ],
                joinData:{
                    "join": require('@/assets/contact/contact_join_01.png'),
                    "team": require('@/assets/contact/contact_join_02.png'),
                    "staff":require('@/assets/contact/contact_join_03.png'),
                },
            };
        },
        //
        components:{
            myMenu,ChpcFooter,contactItem,joinItem,ContactDialog,ContactFloat,
            MobileHeader,MobileLink,MobileFooter,MobileContact,MobileJoin,MobileBanner,MobileContactDialog
        },
        computed: {
            bannerStyle() {
                return {
                    backgroundImage: `url(${this.contactBanner})`,
                };
            }
        },
        mounted() {
            this.getPic();
            this.setContactData();
            window.addEventListener('resize', this.setContactData);
        },
        methods: {
            change(){
                this.isVisible = false;
            },
            showContact(){
                this.isVisible = true;
            },
            contactMobile(){
                this.isVisibleMobile = true;
            },
            closeMobileContact(){
                this.isVisibleMobile = false;
            },
            switchTab(tab) {
                this.activeTab = tab;
                this.gotoSub(tab);
            },
            hoverIndexFun(index){
                this.hoverIndex = index;
                this.selectIndex = index;
            },
            offhoverIndexFun(index){
                if(this.activeTab== 'contact'){
                    this.selectIndex = 0 ;
                }else{
                    this.selectIndex = 1 ;
                }

                this.hoverIndex = -1;
            },
            gotoSub(url){
                url = '/' + url;
                if (url.includes('#')) {
                    this.$router.push(url).then(() => {
                        this.scrollToAnchor(url.split('#')[1]);
                    });
                } else {
                    if (this.$route.path !== url){
                        this.$router.push(`${url}`).then(() => {
                            window.scrollTo(0, 0);
                        });
                    }
                }
            },
            setContactData() {
                if (window.innerWidth <= 768) { // 假设 768px 以下为移动端
                    this.contactData = this.contactDataMobile;
                } else {
                    //this.contactData = this.contactDataDesktop;
                }
            },
            getPic(){
                let pic ={model:5}
                this.$HTTP.getPicByModel(pic).then(resp => {
                    if(resp.code == 200){
                        let data = resp.data;
                        if(data && data.length>0){
                            let picarr= commonFun.dealPic(data,1,false);
                            if(picarr && picarr.length>0){
                                this.contactBanner = picarr;
                            }
                            let aboutImg = commonFun.dealPic(data,2,false);
                            if(!isNull(aboutImg)){
                                this.contactData[0].lanhuBg5 = aboutImg;
                                //console.log(this.contactData)
                            }
                            let aboutImg2 = commonFun.dealPic(data,3,false);
                            if(!isNull(aboutImg2)){
                                this.contactData[1].lanhuBg5 = aboutImg2;
                            }
                            //
                            let aboutImg4 = commonFun.dealPic(data,4,false);
                            if(!isNull(aboutImg4)){
                                this.joinData.join = aboutImg4;
                            }
                            let aboutImg5 = commonFun.dealPic(data,5,false);
                            if(!isNull(aboutImg5)){
                                this.joinData.team = aboutImg5;
                            }
                            let aboutImg6 = commonFun.dealPic(data,6,false);
                            if(!isNull(aboutImg6)){
                                this.joinData.staff = aboutImg6;
                            }
                        }
                    }
                });
            }

        }
    };
</script>
<style scoped lang="css" src="./css/index.css" />
